module.exports = __webpack_public_path__ + "static/media/imageDrag.fc866f9a.svg";